import React, { Component } from 'react';
import { Link,   BrowserRouter as Router,
    Switch,
    useLocation } from 'react-router-dom';
import { Button, Menu } from 'antd';

import logo from './logo.png';
import { MailOutlined, AppstoreOutlined, SettingOutlined } from '@ant-design/icons';

import { useState } from '../../state/StateProvider';

const PluginHeader = props => {
    const { isOnboarded = true } = props;
    let location = useLocation();
    const path = location.pathname;

    const { state, apiKey } = useState();
    const { apiKeyValid, user } = state;

    const { plan, isYearly, isActive } = user;

    // console.log(path);

    const upgradeHeader = () => {
        if (plan === '') return (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <span style={{ marginRight: 25 }}>
                    Unlicensed version
                </span>
                <Button className="amzw-button amzw-button-header"><a href="https://amzwatcher.com/pricing/" target="_blank">Upgrade</a></Button>
            </div>
        )
        if (plan && plan !== '' && !isYearly) return (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <span style={{ marginRight: 25 }}>
                    Save up to 20% with a yearly subscription
                </span>
                <Button className="amzw-button amzw-button-header"><a href="https://amzwatcher.com/pricing/" target="_blank">Get The Discount</a></Button>
            </div>
        )
        if (plan && plan !== '' && isYearly) return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: 25 }}>
                    Licensed version
                </span>
            </div>
        )
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: 25 }}>
                Unlicensed version
                </span>
            </div>
        )
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div id="#nag-container"></div>
            <div style={{ height: 80 }}>
                <div style={{ marginTop: 30, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div>
                        <img src={logo} alt="logo" width="225px" />
                    </div>
                   {upgradeHeader()}
                </div>
            </div>
            <div>
                <Menu selectedKeys={[path]} mode="horizontal">
                    <Menu.Item key="/report/" style={{ marginLeft: 0 }} disabled={!isOnboarded}>
                        <Link to="/report/">Site Report</Link>
                    </Menu.Item>
                    <Menu.Item key="/settings/" disabled={!isOnboarded}>
                        <Link to="/settings/">Settings</Link>
                    </Menu.Item>
                    <Menu.Item key="/help/" disabled={!isOnboarded}>
                        <Link to="/help/">Help</Link>
                    </Menu.Item>
                </Menu>
            </div>
        </div>
    );
}

export default PluginHeader;
